import { useContext, useMemo } from "react";
import { SurveyComponent } from "@tree-company/tree-query";
import { Survey } from "@tree-company/tree-query";
import { getSurveySettings } from "../survey";
import { LocaleContext } from "../app";

export default function View() {
  const { locale } = useContext(LocaleContext);
  const survey = useMemo(() => new Survey(getSurveySettings(locale)), [locale]);

  return <SurveyComponent survey={survey} />;
}
